export default {
	isDevEnvironment: (
		process.env.NODE_ENV === "development"
	) || (
		window && window.origin && window.origin.includes("localhost")
	)
};
